import { render, staticRenderFns } from "./FormListaEmpaque.vue?vue&type=template&id=0b116a8f&scoped=true&"
import script from "./FormListaEmpaque.vue?vue&type=script&lang=js&"
export * from "./FormListaEmpaque.vue?vue&type=script&lang=js&"
import style0 from "./FormListaEmpaque.vue?vue&type=style&index=0&id=0b116a8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b116a8f",
  null
  
)

export default component.exports